import { ProLayoutProps } from '@ant-design/pro-components';
import edatlinkLogo from '@/pages/User/images/edatlink_icon.png';
import iybLogo from '@/pages/User/images/iyb_icon.png';
import {BaseRouteUrl} from "./BASEURLCONFIG";
/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#1890ff',
  layout:'mix',
  splitMenus:true,
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: ' 智慧应用平台',
  pwa: true,
  logo: BaseRouteUrl + '/image/edatlink_logo.svg',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
